import { PrivacyPolicyPage, PrivacyPolicyPageQuery } from '@/graphql/generated/graphql';

import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_PRIVACY_POLICY_PAGE } from '@/graphql/queries/privacy-policy/privacy-policy';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<PrivacyPolicyPageQuery>({
      query: QUERY_PRIVACY_POLICY_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.privacyPolicyPage?.data?.attributes as PrivacyPolicyPage,
    error,
  };
};
